import React, { useEffect, useState } from "react";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";
import { makeStyles } from "@mui/styles";
// import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
// import { AiOutlineSearch } from "react-icons/ai";
// import { AiOutlineUserAdd } from "react-icons/ai";
// import { AiOutlineFileAdd } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from "antd";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
    resetGetwalletownerconfigurationlist,
    getwalletownerconfigurationlistReq
} from "../../redux/actions/getwalletownerconfigurationlistAction";

import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";

import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import SearchIcon from "@mui/icons-material/Search";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import { getWalletAcRequired } from "../../redux/actions/walletAcRequiredAction";
import { resetGetUpdateCommomConfAdmin } from "../../redux/actions/getUpdateCommomConfDetailsAdminAction";
import val from "../../getThemeDetails"

const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const AdminConfiguration = () => {
    const navigate = useHistory();
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [role, setRole] = useState("");
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page, setPage] = useState(0);
    const [getViewCongigurationResArray, setGetViewCongigurationResArray] =
        useState("");
    const [getwalletownerconfigListStatus, setGetwalletownerconfigListStatus] =
        useState(false);
    const [getwalletownerconfigListArray, setGetwalletownerconfigListArray] =
        useState("");
    const [walletOwner, setWalletOwner] = useState("");
    const [walletOwnerTableStatus, setWalletOwnerTableStatus] = useState(false);
    const [walletOwnerTableArray, setWalletOwnerTableArray] = useState([]);
    const dispatch = useDispatch();
    const handleChange = ({ target: { name, value } }) => {
        if (name === "role") {
            setRole(value == "Select Role" ? "" : value);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };



    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const getWalletRolesRes = useSelector(
        ({ walletAcRequired }) => walletAcRequired
    );

    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );

    //getwalletownerconfigurationlist
    const getOwnerAndNameList = useSelector(
        ({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
    );


    const getwalletownerconfigurationlistRes = useSelector(
        ({ getwalletownerconfigurationlist }) => getwalletownerconfigurationlist
    );


    const authToken = regenerateTokenRes.data?.AuthToken || "";

    // var authToken = regenerateTokenRes.data.AuthToken;

    const getWalletOwnerIdAndNameListTableRequest = () => {
        setIsLoading(true);
        setWalletOwnerTableStatus(true);
        const getWalletOwnerIdAndNameListReq = {
            loginDetails: {
                // adminId: 2
                adminId: val.adminIDS

            }
        };
        dispatch(
            getWalletOwnerIdAndNameList(getWalletOwnerIdAndNameListReq, authToken)
        );
    };

    // useEffect(() => {
    //     getWalletOwnerIdAndNameListTableRequest()
    // }, [])

    useEffect(() => {
        // Initial fetch of wallet owner list when component mounts
        // This will happen only once unless dependencies change
        if (authToken) { // Only dispatch if authToken is available
            getWalletOwnerIdAndNameListTableRequest();
        }
    }, [authToken]); // Dependency on authToken to re-run if token changes

    useEffect(() => {
        console.log("made get req for getOwnerAndNameList");
        if (walletOwnerTableStatus) { // Check if the request was actually made
            if (getOwnerAndNameList.data.status === "success") {
                setIsLoading(false);
                setWalletOwnerTableArray([].concat(getOwnerAndNameList.data.ownerList));
            } else if (getOwnerAndNameList.data.status === "failed") {
                setIsLoading(false);
                setWalletOwnerTableArray([]); // Clear array on failure
                if (getOwnerAndNameList.data.description === "session out") {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                } else if (getOwnerAndNameList.data.description === "Authorization failed") {
                    // This is the key change: dispatch regenerateToken
                    // The subsequent useEffect will handle re-fetching after regeneration
                    dispatch(regenerateToken(authToken, regenerateTokenRes.data.partnerId));
                }
            }
        }
    }, [getOwnerAndNameList, walletOwnerTableStatus, dispatch, authToken, regenerateTokenRes.data.partnerId]);

    // Effect to handle regenerateToken success and then re-call getWalletOwnerIdAndNameListTableRequest
    useEffect(() => {
        if (regenerateTokenRes.status === "success" && regenerateTokenRes.data.AuthToken) {
            console.log("Token regenerated successfully, re-fetching wallet owner list.");
            // Re-call the function to fetch wallet owner list with the new token
            getWalletOwnerIdAndNameListTableRequest();
        } else if (regenerateTokenRes.status === "failed") {
            // Handle regenerate token failure (e.g., show an error message, force logout)
            console.error("Token regeneration failed:", regenerateTokenRes.error);
            // Optionally, you might want to log out the user here if token regeneration consistently fails
            SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId); // Example: force logout on regeneration failure
        }
    }, [regenerateTokenRes.status, regenerateTokenRes.data.AuthToken, dispatch, authToken, regenerateTokenRes.data.partnerId]);

    // const getWalletOwnerListResFunc = () => {
    //     if (walletOwnerTableStatus) {
    //         if (getOwnerAndNameList.data.status == "success") {
    //             // setIsLoading(false);
    //             setWalletOwnerTableArray([].concat(getOwnerAndNameList.data.ownerList));
    //         }
    //         if (getOwnerAndNameList.data.status === "failed") {
    //             // setIsLoading(false);
    //             setWalletOwnerTableArray(getOwnerAndNameList.data.ownerList);
    //             if (
    //                 getOwnerAndNameList.data.description == "session out"
    //             ) {
    //                 SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //             }
    //             if (
    //                 getOwnerAndNameList.data.description == "Authorization failed"
    //             ) {
    //                 regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //             }
    //         }
    //     }
    // };

    // useEffect(() => {
    //     console.log("made get req");
    //     getWalletOwnerListResFunc();
    // }, [getOwnerAndNameList]);

    const getConfigurationListApi = () => {
        setGetwalletownerconfigListStatus(true);
        setIsLoading(true);
        const getwalletownerconfigurationlistReqs = {
            loginDetails: {
                walletOwnerId: walletOwner == "Select Owner Id" ? "" : walletOwner.split("-")[0]
            },
            actionCustomerMasterRequestVO: {
                role: role
            }
        };
        return dispatch(
            getwalletownerconfigurationlistReq(
                getwalletownerconfigurationlistReqs,
                authToken
            )
        );
    };

    useEffect(() => {
        if (getwalletownerconfigListStatus) {
            if (getwalletownerconfigurationlistRes.data.status == "Success") {
                setGetwalletownerconfigListArray(
                    [].concat(getwalletownerconfigurationlistRes.data.walletRolesList)
                );
                setIsLoading(false);
            }
            if (getwalletownerconfigurationlistRes.data.status == "failed") {
                setGetwalletownerconfigListArray(
                    getwalletownerconfigurationlistRes.data
                );
                setIsLoading(false);
                if (
                    getwalletownerconfigurationlistRes.data.description ==
                    "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getwalletownerconfigurationlistRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }, [getwalletownerconfigurationlistRes.data.status]);

    // useEffect(() => {
    //   getConfigurationListApi();
    // }, []);
    const WalletAcRequiredFunc = (walletOwnerId) => {
        const WalletAcRequired = {
            authentication: {
                partnerId: walletOwnerId.split("-")[0]
            },
        };

        return dispatch(getWalletAcRequired(WalletAcRequired, authToken));
    };
    const handleChangeWallet = ({ target: { name, value } }) => {
        if (name === "walletOwner") {
            setWalletOwner(value == "Select Owner ID" ? "" : value);
            WalletAcRequiredFunc(value)

        }
    };




    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            getConfigurationListApi();
        }
    }, [regenerateTokenRes.data.status]);

    useEffect(() => {
        if (getwalletownerconfigListStatus) {
            if (getwalletownerconfigurationlistRes.data.status == "Success") {
                setGetwalletownerconfigListArray(
                    [].concat(getwalletownerconfigurationlistRes.data.walletRolesList1)
                );
                setIsLoading(false);
            }
        }
    }, [getwalletownerconfigurationlistRes.data.status]);

    const viewHandleClickOpen = (id, wId) => {
        navigate.push({
            pathname: `/index/AdminViewConfiguration`,
            search: `?userId=${id}&walletId=${wId}`,

        });
    };

    const updateEditHandleClick = (id, wId) => {
        navigate.push({
            pathname: `/index/AdminUpdateConfiguration`,
            search: `?userId=${id}&walletId=${wId}`
        });
    };


    return (
        <Layout>
            <Card>
                {/* <BackButton /> */}
                <Grid
                    container
                    style={{ padding: "25px", gap: "20px", justifyContent: "right" }}
                >
                    <Grid item md={3} sm={12} xs={12} lg={3}>
                        <NavLink to="/index/AdminAddNewConfiguration">
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                            >
                                Add New Configuration
                            </CustomButton>
                        </NavLink>
                    </Grid>
                    <Grid item md={3} sm={12} xs={12} lg={3}>
                        <NavLink to="/index/AdminCommonCongigurationList">
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                            >
                                Common Configuration
                            </CustomButton>
                        </NavLink>
                    </Grid>
                    {/* <Grid item md={3} sm={12} xs={12} lg={3}>
                        <NavLink to="/index/addNotification">
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                            >
                                Add Notification
                            </CustomButton>
                        </NavLink>
                    </Grid> */}
                </Grid>

                <Grid
                    container
                    spacing={2}
                    style={{ padding: "25px", marginTop: "2rem" }}
                >
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <TextField
                            select
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Owner ID"
                            type="name"
                            fullWidth
                            variant="standard"
                            name="walletOwner"
                            onChange={handleChangeWallet}
                            // value={walletOwner || "Select Owner ID"}
                            defaultValue={"Select Owner ID" || walletOwner}
                        >
                            <MenuItem value="Select Owner ID" selected="Select Owner ID">
                                Select Owner ID
                            </MenuItem>
                            {getOwnerAndNameList.data.ownerList &&
                                getOwnerAndNameList.data.ownerList &&
                                []
                                    .concat(getOwnerAndNameList.data.ownerList)
                                    .map((dropdown) => (
                                        <MenuItem value={dropdown}>{dropdown}</MenuItem>
                                    ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <TextField
                            select
                            size="small"
                            margin="dense"
                            color="primary"
                            autoFocus={true}
                            variant="standard"
                            type="text"
                            label="Role"
                            fullWidth={true}
                            name="role"
                            defaultValue={"Select Role" || role}
                            onChange={handleChange}
                        >
                            <MenuItem value="Select Role" selected="Select Role">
                                Select Role
                            </MenuItem>
                            {getWalletRolesRes.data.rolesList &&
                                getWalletRolesRes.data.rolesList &&
                                []
                                    .concat(getWalletRolesRes.data.rolesList)
                                    .map((dropdown) => (
                                        <MenuItem value={dropdown}>{dropdown}</MenuItem>
                                    ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={4} container>
                        <Grid>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={getConfigurationListApi}
                            >
                                Search <SearchIcon />
                            </CustomButton>
                        </Grid>
                        <Grid item md={7}></Grid>
                    </Grid>
                </Grid>
            </Card>

            {isLoading ? (
                <LoadingSpinner />
            ) : getwalletownerconfigListArray.length == undefined ||
                !getwalletownerconfigListStatus ? (
                <Card>
                    <Grid
                        container
                        style={{
                            padding: "10px"
                        }}
                    >
                        <Grid xs={12} sm={12} md={12} lg={12}>
                            <Typography
                                variant="body1"
                                style={{ fontWeight: "700" }}
                                className="themeText"
                            >
                                Customer Master
                            </Typography>
                        </Grid>

                        <Grid xs={12} sm={12} md={12} lg={12}>
                            <Alert
                                className="my-3 tableHeaderColor"
                                variant="secondary"

                            >
                                No Records Found!
                            </Alert>
                        </Grid>
                    </Grid>
                </Card>
            ) : (
                <Card>
                    <Grid
                        container
                        style={{
                            padding: "10px"
                        }}
                    >
                        <Grid xs={12} sm={12} md={12} lg={12}>
                            <Typography
                                variant="body1"
                                style={{ fontWeight: "700" }}
                                className="themeText"
                            >
                                Customer Master
                            </Typography>
                        </Grid>
                        <TableContainer component={Paper} className="my-3">
                            <Table
                                className={classes.table}
                                size="small"
                                aria-label="a dense table"
                            >
                                <TableHead>
                                    <TableRow className="tableHeaderColor">
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            Role
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ fontWeight: "bold", color: "white" }}
                                        >
                                            Action
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {getwalletownerconfigListArray &&
                                        []
                                            .concat(getwalletownerconfigListArray)
                                            .slice(
                                                page * rowsPerPage,
                                                page * rowsPerPage + rowsPerPage
                                            )
                                            .map((row, index) => (
                                                <TableRow key={index}>
                                                    <TableCell align="center">{row.role}</TableCell>

                                                    <TableCell
                                                        align="center"
                                                    // style={{ display: "flex" }}
                                                    >
                                                        <Tooltip title="View">
                                                            <CustomButton
                                                                style={{
                                                                    padding: "8px"
                                                                }}
                                                                onClick={() => viewHandleClickOpen(row.role, row.walletOwnerId)}
                                                            >
                                                                {
                                                                    <VisibilityIcon
                                                                        style={{
                                                                            color: "#fff",
                                                                            fontSize: "20px"
                                                                        }}
                                                                    />
                                                                }
                                                            </CustomButton>
                                                        </Tooltip>

                                                        <Tooltip title="Edit">
                                                            <CustomButton
                                                                style={{
                                                                    padding: "8px"
                                                                }}
                                                                onClick={() =>
                                                                    updateEditHandleClick(row.role, row.walletOwnerId)
                                                                }
                                                            >
                                                                {
                                                                    <EditIcon
                                                                        style={{
                                                                            color: "#fff",
                                                                            fontSize: "20px"
                                                                        }}
                                                                    />
                                                                }
                                                            </CustomButton>
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                </TableBody>
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={getwalletownerconfigListArray.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </TableContainer>
                    </Grid>
                </Card>
            )}
        </Layout>
    );
}

export default AdminConfiguration
